import React, {useEffect, useRef} from 'react';
import {connect} from "react-redux";

import {SIDEBAR_SLAB_BUTTONS, SIDEBAR_SLAB_SEAM_BUTTONS} from "../../../../../constants";
import {FormattedMessage} from "react-intl";
import {animateButtons, hideButtons} from "../../../../SqftUiFunctions";
import {setSQFTActiveButton} from "../../../../../../../actions/sqftMenuFunctions";
import sqftShapeManager from "../../../../canvas/store/sqftShapeManager";

export const setNewLayout = () => {
};

const SqftNavSeam = (props) => {
  // other popups, modals and so on
  const {menuOpened, activeButton, setSQFTActiveButton} = props;
  const buttonRefs = useRef({});
  const expanded = menuOpened
    && (activeButton === SIDEBAR_SLAB_BUTTONS.seam || activeButton in SIDEBAR_SLAB_SEAM_BUTTONS);

  useEffect(() => {
    const buttons = Object.values(buttonRefs.current);
    if (expanded) {
      animateButtons(buttons);
    } else {
      hideButtons(buttons);
    }

  }, [expanded]);

  const handleButtonClick = (itemName) => {
    setSQFTActiveButton(itemName);
    switch (itemName) {
      case SIDEBAR_SLAB_SEAM_BUTTONS.undoSeam:
          sqftShapeManager.undoSeam();
        break;
      case SIDEBAR_SLAB_SEAM_BUTTONS.resetSeams:
          sqftShapeManager.resetAllSeams();
        break;
      default:
        break;
    }
  };

  return (
    <div className={"seam side single" + (expanded ? " expanded" : "")}>
      <div className="sidebar-buttons sidebar-buttons-column">
      {
        Object.keys(SIDEBAR_SLAB_SEAM_BUTTONS).map((item, index) => {
          let className = ("button button--finished-transition button--" + item + (activeButton === item ? " button--active" : ""));
          return (
            <button key={index}
                    ref={el => buttonRefs.current[index] = el}
                    className={className}
                    onClick={() => handleButtonClick(item)}>
              <span className="button-text">
                <FormattedMessage id={"sqft.navigation.slabmenu." + item}/>
              </span>
            </button>
          )
        })
      }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    activeButton: store.sqftMenuState.activeButton
  };
};

const mapDispatchToProps = {
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavSeam);
